module.exports = __webpack_public_path__ + "static/media/YB5M12_1.e1f83b4a.jpg";